import axios from 'axios'
import React, { useEffect, useState } from 'react'
import authService from '../../../Components/Login/auth.service'
//const uuidv4 = require('uuid/v4')

export default function Modal({ setOpenModal, modalInfo }) {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  var user = authService.getCurrentUser()
  const [modal, setModal] = useState(false)

  const toggleModal = () => {
    setModal(!modal)
  }
  const [classificao, setClassificao] = useState([])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/classificacao/list/' +
        user[0].IdEmpresa
      )
      .then(response => {
        setClassificao(response.data)
      })
  }, [])
  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdTexto: modalInfo.IdTexto,
    IdEmpresa: modalInfo.IdEmpresa,
    txtNotaTexto: modalInfo.txtNotaTexto,
    txtNotaValor: modalInfo.txtNotaValor,
    txtTexto: modalInfo.txtTexto,
    txtStatus: modalInfo.txtStatus,
    txtObservacoes: modalInfo.txtObservacoes,
    txtAlteradoPor: user[0].pesEmail,
    txtAlteradoEm: newDate
  })
  function handleInputChange(event) {
    if (event.target.name === 'txtStatus') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
  }
  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .put(
        process.env.REACT_APP_API_URL + '/api/v1/texto/' + campos.IdTexto,
        campos
      )
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }
  return (
    <div className="modalArea">
      <div onClick={toggleModal} className="overlay"></div>
      <div className="modalPadrao-content">
        <div className="cxTituloPadrao">
          <h1>
            Editar Texto
            <hr className="hrTitleModal" />
          </h1>
          <button
            onClick={() => {
              setOpenModal(false)
            }}
          >
            X
          </button>
        </div>

        <form onSubmit={handleFormSubmit}>
          <div className="lineModal">
            <label>Classificação:</label>
            <label style={{ width: '90px' }}>Nota:</label>
          </div>
          <div className="lineModal">
            <select
              id="fname1"
              name="txtNotaTexto"
              onChange={handleInputChange}
              required
            >
              <option value="">Selecione</option>
              {classificao
                .filter(val => {
                  if (val.clsStatus === 1) {
                    return val
                  }
                })
                .map(classificacao => (
                  <option value={classificacao.clsDescricao}>
                    {classificacao.clsDescricao}
                  </option>
                ))}
            </select>
            <input
              type="number"
              id="fname"
              defaultValue={campos.txtNotaValor}
              name="txtNotaValor"
              style={{ width: '80px' }}
              onChange={handleInputChange}
              step=".01"
              min={0}
            ></input>
          </div>

          <label>Descrição:</label>
          <input
            type="text"
            id="fname"
            defaultValue={campos.txtTexto}
            name="txtTexto"
            onChange={handleInputChange}
          ></input>

          <label>Observações:</label>
          <textarea
            type="text"
            id="fname"
            name="txtObservacoes"
            defaultValue={campos.txtObservacoes}
            row="none"
            onChange={handleInputChange}
            maxLength="500"
          ></textarea>
          <div className="caixaSalvarPadrao">
            <div className="InputAuthorization4">
              <label>
                <input
                  name="txtStatus"
                  type="checkbox"
                  defaultChecked={!!campos.txtStatus}
                  onChange={handleInputChange}
                />
                <span>Status</span>
              </label>
            </div>
            <button type="submit">Salvar Registro</button>
          </div>
        </form>
      </div>
    </div>
  )
}
